import * as THREE from "three";

// RoomEnvironment's API, inverted gradient instead of a studio box: an inside-out
// sphere, bright at the nadir, dim at the zenith. Vertex colours rather than a shader
// so the geometry's own +Y fixes the direction (no equirect flipY to get wrong), and
// luminance may exceed 1 since the PMREM target is float.
export class GradientEnvironment extends THREE.Scene {
  constructor({
    down = 1.6, up = 0.2, exponent = 1.5,
    downColor = 0xffffff, upColor = 0xffffff,
  } = {}) {
    super();
    this.name = "GradientEnvironment";

    const geometry = new THREE.SphereGeometry(1, 32, 24);
    const position = geometry.attributes.position;
    const colors = new Float32Array(position.count * 3);

    // Each end is its own tint scaled by its own luminance; equal tints reproduce a
    // plain white gradient.
    const nadir = new THREE.Color(downColor).multiplyScalar(down);
    const zenith = new THREE.Color(upColor).multiplyScalar(up);
    const scratch = new THREE.Color();

    for (let i = 0; i < position.count; i++) {
      // t: 0 = down, 1 = up; exponent > 1 keeps the nadir value dominant further up.
      const t = (position.getY(i) + 1) / 2;
      scratch.copy(nadir).lerp(zenith, Math.pow(t, exponent));
      colors[i * 3] = scratch.r;
      colors[i * 3 + 1] = scratch.g;
      colors[i * 3 + 2] = scratch.b;
    }

    geometry.setAttribute("color", new THREE.BufferAttribute(colors, 3));

    this.add(new THREE.Mesh(geometry, new THREE.MeshBasicMaterial({
      side: THREE.BackSide,
      vertexColors: true,
    })));
  }

  dispose() {
    this.traverse((object) => {
      if (!object.isMesh) return;
      object.geometry.dispose();
      object.material.dispose();
    });
  }
}
